import { render } from "./VersionNotes.vue?vue&type=template&id=3909150b&scoped=true"
import script from "./VersionNotes.vue?vue&type=script&lang=js"
export * from "./VersionNotes.vue?vue&type=script&lang=js"

import "./VersionNotes.vue?vue&type=style&index=0&id=3909150b&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3909150b"]])

export default __exports__